import React from "react";
import Chart from "devextreme-react/chart";
import ChartCard from "components/common/pyramid/ChartCard";

const PyramidPivotChart = ({ chartRef, palette, title }) => {
  const chartConfig = {
    commonSeriesSettings: {
      type: "bar",
    },
    size: {
      height: 300,
    },
    adaptiveLayout: {
      width: 450,
    },
    tooltip: {
      enabled: true,
      customizeTooltip: (args) => {
        const formatter = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "EUR",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
        return {
          text: `${args.seriesName} | ${formatter.format(args.value)}`,
        };
      },
    },
    export: {
      enabled: false,
    },
    palette: palette,
  };

  return (
    <ChartCard title={title} chartRef={chartRef} palette={palette}>
      <div className="p-2">
        <Chart ref={chartRef} id="pivotgrid-chart" {...chartConfig} />
      </div>
    </ChartCard>
  );
};

export default PyramidPivotChart;
